import cn from "classnames";
import { memo } from "react";
import {
  Checkmark as CheckmarkIcon,
  ExclamationMark as ExclamationMarkIcon,
} from "@rshbintech.dboul/icons";
import { AttachmentFile as AttachmentFileImage } from "@rshbintech.dboul/images";
import { Loader } from "@rshbintech.dboul/core-ui";
import { DOCUMENT_SIGNING_STAGES } from "../../constants";
import { DocumentIconProps } from "./types";
import styles from "./styles.scss";

export const DocumentIcon = memo(
  ({ signingStage, isError }: DocumentIconProps) =>
    (() => {
      if (isError) {
        return (
          <div className={cn(styles.wrapper, styles.error)}>
            <ExclamationMarkIcon size="medium" type="danger" />
          </div>
        );
      }

      if (
        signingStage !== DOCUMENT_SIGNING_STAGES.EMPTY &&
        signingStage !== DOCUMENT_SIGNING_STAGES.FINISHED &&
        signingStage !== null
      ) {
        return (
          <div className={styles.wrapper}>
            <Loader size="small" type="spinner" />
          </div>
        );
      }

      if (signingStage === DOCUMENT_SIGNING_STAGES.FINISHED) {
        return (
          <div className={styles.wrapper}>
            <CheckmarkIcon size="medium" type="primary" />
          </div>
        );
      }

      return <AttachmentFileImage className={styles["attachment-icon"]} />;
    })()
);
